interface FetchError extends Error {
  response?: { status: number }
}

interface RefreshResponse {
  data?: { user?: { id: number, email: string, name: string, first_name: string, last_name: string, avatar_url: string | null, role: string, global_role: string, groups: { id: number, name: string }[] } }
}

export default defineNuxtPlugin(() => {
  let refreshing: Promise<boolean> | null = null

  const originalFetch = globalThis.$fetch as (request: string, opts?: Record<string, unknown>) => Promise<unknown>

  globalThis.$fetch = ((request: RequestInfo, opts?: Record<string, unknown>) => {
    const doFetch = async () => {
      try {
        return await originalFetch(request as string, opts)
      }
      catch (err: unknown) {
        const fetchErr = err as FetchError
        const isAuthRoute = typeof request === 'string' && (
          request.includes('/api/auth/refresh')
          || request.includes('/api/auth/login')
          || request.includes('/api/auth/session')
        )

        if (fetchErr?.response?.status === 401 && !isAuthRoute && !(opts as Record<string, unknown> | undefined)?._retried) {
          const authStore = useAuthStore()
          if (authStore.loggingOut) throw err

          if (!refreshing) {
            refreshing = originalFetch('/api/auth/refresh', { method: 'POST' })
              .then((res: unknown) => {
                const data = res as RefreshResponse
                if (data?.data?.user) {
                  authStore.user = data.data.user
                }
                return true
              })
              .catch(() => false)
              .finally(() => { refreshing = null })
          }

          const success = await refreshing
          if (success) {
            return await originalFetch(request as string, { ...opts, _retried: true })
          }

          if (authStore.loggingOut) throw err

          authStore.user = null
          const currentPath = window.location.pathname + window.location.search
          window.location.href = `/api/auth/login?state=${encodeURIComponent(currentPath)}`
        }

        throw err
      }
    }
    return doFetch()
  }) as typeof globalThis.$fetch
})
